import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { getRequest, postRequest } from 'utils/api';
import { formatPrice, roundNumber } from 'utils/helpers';
import { closeModal, openModal } from 'features/utilsSlice';
import CenteredDialog from 'components/CenteredDialog';
import SuccessGigDialog from './SuccessGigDialog';

const ApplyGigDialog = ({ addApplication, handleClose }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [suggestedPrice, setSuggestedPrice] = useState(null);
  const { gig, profile } = useSelector(state => state.utils.modalData['Apply Gig']);

  const handleDialogClose = () => dispatch(closeModal('Apply Gig'));

  const handleSubmit = (message, budget) => {
    setIsLoading(true);

    postRequest({
      endpoint: 'gig_applications',
      data: {
        gig_application: {
          budget,
          gig_id: gig.id,
          profile_id: profile.id,
          application_message: message,
        },
      },
    })
      .then(response => {
        addApplication(response.data);
        dispatch(openModal({ name: 'Success Gig' }));
        handleDialogClose();
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  };

  useEffect(() => {
    if (!gig?.id || !profile?.id) return;

    getRequest({
      endpoint: `gigs/${gig.id}/profile_price_estimate`,
      query: { profile_id: profile.id },
    })
      .then(res => setSuggestedPrice(res.price))
      .catch(() => {});
  }, [gig?.id, profile?.id]);

  if (!suggestedPrice) return null;

  return (
    <>
      <CenteredDialog
        modalName="Apply Gig"
        title={`Apply to ${gig?.title}`}
        placeholder="It's a good idea to give the buyer a short personal note to accompany the gig request. Why should they pick you?"
        handleSubmit={handleSubmit}
        handleDialogClose={handleDialogClose}
        isLoading={isLoading}
        defaultPrice={suggestedPrice}
        alwaysEnabled
        priceChoices={[
          { value: suggestedPrice * 0.8, label: '20% off' },
          { value: suggestedPrice * 0.9, label: '10% off' },
          { value: suggestedPrice, label: 'No discount' },
        ]}
      />

      <SuccessGigDialog
        title="Awesome"
        subtitle="The gig has been requested!"
        description="Stay tuned to get confirmation from the advertiser. We’ll notify you if they accept."
        btnText="Ok Cool"
        fingersCrossed
        handleCloseApplication={handleClose}
      />
    </>
  );
};

export default ApplyGigDialog;
